const LightTheme = {
  palette: {
    mode: 'light',
    divider: 'rgba(0, 0, 0, 0.12)',
    text: {
      primary: 'rgba(0, 0, 0, 0.72)',
      secondary: 'rgba(0, 0, 0, 0.51)',
      disabled: 'rgba(0, 0, 0, 0.3)',
      contrast: '#FFFFFF',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
      overlay: 'rgba(0, 0, 0, 0.6)',
      backdrop: 'rgba(0, 0, 0, 0.3)',
    },
    primary: {
      lighter: '#f8a0d0',
      light: '#E75AA8',
      main: '#DB238A',
      dark: '#881052',
      contrastText: '#fff',
    },
    secondary: {
      lighter: '#f0f0f0',
      light: '#9a9a9a',
      main: '#454545',
      dark: '#000000',
      contrastText: '#fff',
    },
    error: {
      lighter: '#ffdbcc',
      light: '#ffb798',
      main: '#f95301',
      dark: '#ac3700',
      contrastText: '#fff',
    },
    warning: {
      lighter: '#fff7cc',
      light: '#ffd702',
      main: '#fab001',
      dark: '#a9460c',
      contrastText: '#fff',
    },
    info: {
      lighter: '#cfecfc',
      light: '#acdffa',
      main: '#5dbbe7',
      dark: '#025082',
      contrastText: '#fff',
    },
    success: {
      lighter: '#eff8d3',
      light: '#cfdf32',
      main: '#a0ca23',
      dark: '#538329',
      contrastText: '#fff',
    },
    grey: {
      0: '#ffffff',
      50: '#fcfcfc',
      100: '#fafafa',
      200: '#f5f5f5',
      300: '#f0f0f0',
      400: '#d9d9d9',
      500: '#bfbfbf',
      600: '#8c8c8c',
      700: '#595959',
      800: '#434343',
      900: '#000000',
    },
    brand: {
      blue: '#53b3e4',
      green: '#8ac541',
      purple: '#a576a7',
      yellow: '#fdd106',
      gray: '#707272',
      magenta: '#DB238A',
      black: '#000000',
    },
    tag: {
      secondary: {
        light: '#f5f5f6',
        dark: '#111827',
      },
      success: {
        light: '#cefcdd',
        dark: '#07a287',
      },
      warning: {
        light: '#ffefd8',
        dark: '#db8d17',
      },
      error: {
        light: '#ffeded',
        dark: '#eb5757',
      },
      errorFilled: {
        light: '#eb5757',
        dark: '#ffeded',
      },
      errorFilledPurple: {
        light: '#a576a7',
        dark: '#fff3ff',
      },
      info: {
        light: '#dfecff',
        dark: '#4f71e7',
      },
      infoFilled: {
        light: '#6e8eac',
        dark: '#ffffff',
      },
    },
  },
}

export default LightTheme
